import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABand({
  eyebrow = "Work with Meta61",
  title = "Build what the future will trust.",
  body = "Whether you are an enterprise, a government, or a peak body shaping standards — let's talk.",
  showAssessment = false,
}) {
  return (
    <section className="m61-section border-t border-m61-line" data-testid="cta-band">
      <div className="m61-container">
        <div className="relative overflow-hidden rounded-2xl border border-m61-line bg-m61-surface p-10 lg:p-16">
          <div className="m61-grid-bg absolute inset-0 opacity-40" aria-hidden="true" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <p className="m61-eyebrow mb-5">{eyebrow}</p>
              <h2 className="m61-h2 mb-4">
                {title.includes("trust") ? (
                  <>
                    Build what the future will <span className="m61-gradient-text">trust.</span>
                  </>
                ) : (
                  title
                )}
              </h2>
              <p className="m61-lead max-w-2xl">{body}</p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col lg:items-end gap-4">
              <Link to="/contact" className="m61-btn-primary" data-testid="cta-contact">
                Start a conversation <ArrowRight className="w-4 h-4" />
              </Link>
              {showAssessment && (
                <Link to="/resources#assessment" className="m61-btn-ghost" data-testid="cta-assessment">
                  Take the Readiness Assessment
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
